import React from "react"
import HotspotText from "./HotspotText";

const HotspotImage = ({image, imageAlt, title, text}) => {
    return (
        <div className="image">
            <div className="img-container">
                <img fadeIn="true" src={image} alt={imageAlt}></img>
            </div>
            <HotspotText title={title} text={text} />
        </div>
    )
}

export default HotspotImage;